//v1.0.0 create and manage all controllers
//v1.0.1 added DOMReady / DOMUpdated functions
import { Controller } from 'core/Controller';
import { Events } from 'core/events/Events';
import { CoreEvents } from 'core/events/CoreEvents';

interface ControllerConfig {
	instance: Controller | any;
	global?: boolean;
	selector?: string;
}

export class ControllerManager {
	private _controllers: Array<Controller> = [];

	public init() {
		//Loop through all the controllers.
		//If they are global then they can be started up straight away
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].global) {
				this._controllers[i].init();
			}
		}

		Events.on(CoreEvents.MODULES_MOUNTED, this._onModulesMounted.bind(this));
	}

	public add(...controllersConfig: Array<ControllerConfig>) {
		for (let i = 0; i < controllersConfig.length; i++) {
			if (controllersConfig[i].global) {
				controllersConfig[i].instance.global = true;
			}
			if (controllersConfig[i].selector) {
				controllersConfig[i].instance.containerSelector = controllersConfig[i].selector;
			}

			this._controllers.push(controllersConfig[i].instance);
		}
	}

	public get(id: string): Controller {
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].id.toLowerCase() === id.toLowerCase()) {
				return this._controllers[i];
			}
		}

		return null;
	}

	public DOMReady(): void {
		this._controllers.forEach((controller) => {
			if (controller.DOMReady) {
				controller.DOMReadyCore();
			}
		});
	}

	public DOMUpdated(): void {
		this._controllers.forEach((controller) => {
			if (controller.DOMUpdated) {
				controller.DOMUpdated();
			}
		});
	}

	public scroll(windowY: number): void {
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].scroll) {
				this._controllers[i].scroll(windowY);
			}
		}
	}

	public resize(sizes: any): void {
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].resize) {
				this._controllers[i].resize();
			}
		}
	}

	public tick(delta: number): void {
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].tick) {
				this._controllers[i].tick(delta);
			}
		}
	}

	private _onModulesMounted(): void {
		for (let i = 0; i < this._controllers.length; i++) {
			if (this._controllers[i].modulesMounted) {
				this._controllers[i].modulesMounted();
			}
		}
	}
}
